import { PhoneNumber } from 'libphonenumber-js';

export function formatPhoneNumber(phoneNumber: PhoneNumber): string {
  return `(+${phoneNumber.countryCallingCode}) ${phoneNumber.nationalNumber}`;
}
